// removed by extract-text-webpack-plugin
module.exports = {"graphic":"Register__graphic___3OrPI","lettering":"Register__lettering___3GQTL","h3":"Register__h3___9coYn"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/register/Register.css
// module id = 532
// module chunks = 0